import * as angular from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../commons/types/vehicle.type";
import {SupplyAccountType} from "../types/supply-account.type";
import {IFilterService, IRootScopeService} from "angular";
import {AccountRequests} from "./account-requests.service";
import {AddressesService} from "../../addresses/services/addresses-service.factory";
import {$agentFactory} from "../../agents/$agent.factory";
import {$agentsFactory} from "../../agents/$agents.factory";
import {$accountsFactory} from "../$accounts.factory";
import {$accountFactory} from "../$account.factory";
import {BranchModel} from "../../branches/models/branch.model";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {PhoneAndEmailFactoryService} from "../../commons/services/phone-and-email-factory.service";
import {SplitService} from "../../commons/services/split-service.service";
import {AccountModel} from "../angular/models/account.model";
import {AccountsFacadeService} from "../angular/services/accounts-facade.service";
import {CommonsService} from "../../commons/services/commons-service.service";

export class AccountDialogService {
  vehicleTypes: VehicleType[];

  /* @ngInject */
  constructor(private $mdDialog, private $log, private $account: $accountFactory, private accountRequests: AccountRequests,
              private $shipper, private $shippers, private $agents: $agentsFactory, private $agent: $agentFactory, private commonsAlertsService: CommonsAlertsService,
              private employmentTypes, private phoneAndEmailFactoryService: PhoneAndEmailFactoryService,
              private splitService: SplitService, private $filter: IFilterService, private uploadFile,
              private systemEventsConfig, private $rootScope: IRootScopeService,
              private commonsService: CommonsService,
              private accountsFacadeService: AccountsFacadeService) {

    this.vehicleTypes = Object.values(VehicleType);

  }

  createDepot(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../../depots/views/dialogs/depot-details-dialog.html').default,
      controller: function ($scope, phoneAndEmailFactoryService: PhoneAndEmailFactoryService, addressesService: AddressesService) {


        const country = self.splitService.getCountryCode();

        $scope.header = 'Create Depot';
        $scope.action = 'Create';
        $scope.isCreate = true;
        $scope.depot = {
          name: undefined,
          phoneNumber: undefined,
          address: {}
        };
        $scope.customAddressEnabled = false;
        $scope.addMarker = {enabled: false};

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onPhoneChange = (mobilePhone, form) => {
          phoneAndEmailFactoryService.phoneFormValidation(mobilePhone, country, form, 'phoneNumber');
          // phoneAndEmailFactoryService.phoneFormValidationAndExists(mobilePhone, country, form, 'phoneNumber');
        }

        $scope.onColorChange = (color) => {
          $scope.depot.displayColor = color;
        }

        $scope.onAddressChange = (address) => {
          $scope.depot.address = address;
        }

        $scope.onLocationButtonToggle = () => {
          $scope.addMarker.enabled = !$scope.addMarker.enabled;
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
          $scope.addMarker.enabled = $scope.customAddressEnabled;
          if (!$scope.customAddressEnabled) {
            $scope.addMarker.enabled = false;
          }
        }

        $scope.onDepotLocationSelect = (location) => {
          if (!$scope.depot.address) {
            $scope.depot.address = {}
          }
          $scope.depot.address.location = addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.depot.phoneNumber = self.$filter<any>('bringozPhonePrefix')($scope.depot.phoneNumber);
              self.$mdDialog.hide($scope.depot);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  //TODO: Not Working.
  inviteAgentToAccount(event, accountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/invite-agent-to-account-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.accountId = accountId;

        $scope.payload = {
          type: 'AGENT'
        };

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////

        $scope.submit = (form) => {
          if (form.$valid) {
            if (!_.isUndefined($scope.payload.userId)) {
              $scope.doUpdate($scope.payload);
            } else {
              form.autocomplete.$setValidity('valid', false);
            }
          } else {
            form.$setSubmitted(true);
          }
        }

        $scope.doUpdate = (payload) => {
          $scope.loading = true;
          self.accountRequests.addUserToAccount(accountId, payload)
            .then(() => {
              $scope.loading = false;
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.$log.error('Invite user to shipper account failed at,' +
                ' accountDialogService@inviteShipperToAccount@doUpdate \n' + error);
              self.$mdDialog.hide();
            })
        }

      }
    });
  }

  addShipperAccount(event, excludeIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-shipper-account-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $log, $accounts: $accountsFactory, $infiniteScroll) {

        $scope.selectedIds = [];
        $scope.excludeIds = excludeIds || [];

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAccountsSelect = (ids) => {
          $scope.selectedIds = ids;
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedIds);
        }

      }
    });
  }

  addDemandAccounts(event, excludeIds, isAllowSelectAll) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-demand-accounts-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $log, $accounts: $accountsFactory, $infiniteScroll) {

        const accountsRef = $accounts(),
          loadLimit = 20;

        $scope.excludeMode = false;
        $scope.isAllowSelectAll = isAllowSelectAll;
        $scope.queryString = undefined;
        $scope.excludeKeys = {};
        $scope.accountKeys = {};

        _.forEach(excludeIds, (id) => {
          $scope.excludeKeys[id] = true;
          $scope.accountKeys[id] = true;
        })

        // ******************************
        //        Private methods
        // ******************************

        $scope._query = () => {
          accountsRef.$query($scope._getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
            .catch((error) => {
              $log.error('Fail to $query', error);
            })
        }

        $scope._getQueryPayload = () => {
          return {
            limit: loadLimit,
            sortByLoad: true,
            isDemand: true,
            type: $scope.type,
            query: $scope.queryString
          }
        }


        accountsRef.$query($scope._getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(accountsRef, loadLimit);


        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.toggleSelectAll = (excludeMode) => {
          $scope.excludeMode = excludeMode;
          $scope.accountKeys = {};
        }

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          $scope._query();
        }

        $scope.onToggle = (account: AccountModel) => {
          $scope.accountKeys[account.id] = !$scope.accountKeys[account.id];
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const accountIds = _.map($scope.accountKeys, (value, key) => {
                if (value) return key;
              });
              self.$mdDialog.hide({
                ids: $scope.excludeMode ? [] : _.compact(accountIds),
                excludeIds: $scope.excludeMode ? _.compact(accountIds) : []
              });
            }
          }
        }

      }
    });
  }

  createNewCarrier(event, accountOptions: string[], accountType?: string) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-new-vendor-account-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        const country = self.splitService.getCountryCode();

        $scope.supplyAccountTypes = SupplyAccountType;
        $scope.accountOptions = accountOptions;
        $scope.tplProviders = self.splitService.getSupportedThreePlProviders();

        $scope.account = {
          name: undefined,
          phoneNumber: undefined,
          email: undefined,
          externalId: undefined,
          country: country,
          type: accountType,
          threePlProviderSettings: undefined,
          branchIds: undefined,
          depotIds: undefined
        }

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onSupplyTypeChange = (type) => {
          if (type !== SupplyAccountType.ThreePLSupply) {
            $scope.account.branchIds = undefined;
            $scope.account.depotIds = undefined;
          }
        }

        $scope.onPhoneChange = (phoneNumber, form) => {
          self.phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, country, form, 'phoneNumber');
          $scope.account.phoneNumber = phoneNumber;
        }

        $scope.onBranchesSelect = (branchIds) => {
          $scope.account.branchIds = branchIds;
        }

        $scope.onDepotsSelect = (depotIds) => {
          $scope.account.depotIds = depotIds;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.account);
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAccount@create');
          }
        }

      }
    })
  }

  createNewAgentInAccount(event, accountId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-new-agent-to-account.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, $mdSelect, $branches) {

        const branchesRef = $branches();

        $scope.loading = false;
        $scope.passwordPolicy = self.splitService.getSitePasswordPolicy();

        $scope.branches = [];
        $scope.employmentTypes = self.employmentTypes;
        $scope.vehicleTypes = self.vehicleTypes;
        $scope.selectedVehicleIds = [];
        $scope.zxExtras = [];

        $scope.payload = {
          accountId: accountId,
          user: {},
          employmentType: 'Independent',
          vehicles: [],
          vehicle: undefined,
        };

        branchesRef.$getAll()
          .then((branchIds) => {
            return branchesRef.$asyncValues(branchIds)
          })
          .then((branches: BranchModel[]) => {
            $scope.branches = branches;
          })
          .catch((error) => {
            self.$log.error(error);
            self.commonsAlertsService.somethingWentWrongError();
          })
          .finally(() => {
            $scope.loading = false;
          });

        $scope.cancel = self.$mdDialog.cancel;
        $scope.closeSelect = $mdSelect.hide;
        /////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onUserChange = (user) => {
          $scope.payload.user = user;
          $scope.zxExtras = user?.email ?
            self.commonsService.buildZxExtras(user.email) :
            [];
        }

        $scope.onChangePassword = (password) => {
          $scope.payload.user.password = password;
        }

        $scope.onChangeVehicles = (vehicles) => {
          $scope.payload.vehicles = vehicles;
          $scope.selectedVehicleIds = _.map(vehicles, (v) => {
            return v.id;
          })
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.loading = true;
              self.$agents().$put($scope.payload)
                .then((agent) => {
                  self.$mdDialog.hide(agent);
                })
                .catch((error) => {
                  $scope.loading = false;
                  self.$log.error('Create new driver failed, accountDialogService@createNewAgentInAccount', error);
                })
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAccount@create');
          }
        }
      }
    })
  }

  editVendorAccount(event: Event, account: AccountModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-vendor-account-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.ready = false;

        $scope.account = account;
        $scope.accountCopy = angular.copy($scope.account);
        $scope.ready = true;
        $scope.logoStatus = 'idle';
        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // ******************************
        //        External methods
        // ******************************


        $scope.onLogoUpload = (res) => {
          $scope.logoStatus = 'complete';
          $scope.accountCopy.avatarUrl = _.get(res, 'data.url');
        }

        $scope.onDeleteAccountAvatar = () => {
          $scope.logoStatus = 'idle';
          $scope.accountCopy.avatarUrl = undefined;
        }

        $scope.submit = (form) => {

          form.$setSubmitted(true);

          if (form.$valid) {

            if (!_.isEqual($scope.account, $scope.accountCopy)) {

              const payload = $scope.accountCopy;

              if (payload) {
                self.accountsFacadeService.editOne(account.id, payload);

                //FIXME
                self.$mdDialog.hide();

                // const errorMessage = 'Edit vendor failed, ' +
                //   'accountDialogService@editVendorAccount@doUpdateAccount';

                // this.changeLoadingState($scope, true);
                // payload.phoneNumber = this.$filter<any>('bringozPhonePrefix')(payload.phoneNumber);
                // this.$account(account.id).$update(payload)
                //     .then((updatedAccount) => {
                //       this.$mdDialog.hide(updatedAccount);
                //     })
                //     .catch((error) => {
                //       this.changeLoadingState($scope, false);
                //       this.$log.error(errorMessage + '\n' + error);
                //     })


                // this.doUpdateAccount($scope, account.id, payload, errorMessage)

              } else {
                self.$log.error('Account copy not found! \n' +
                  '--> accountDialogService@editVendorAccount@update');
              }
            } else {
              self.$mdDialog.hide();
            }

          }

        }
      }
    })
  }

  createShipperAccount(event, branchId?: string, depotId?: string) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-new-shipper-account-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, accountsService) {

        $scope.loading = false;
        $scope.billingAccountMode = "New";

        $scope.account = {
          address: {},
          billingAccount: {
            billingAccountPreferences: {
              invoiceConfiguration: {}
            },
          },
          country: self.splitService.getCountryCode(),
          type: 'BusinessDemand'
        };

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onBillingAccountModeChange = (billingAccountMode) => {
          $scope.billingAccountMode = billingAccountMode;
          if ($scope.billingAccountMode === "New") {
            delete $scope.account.billingAccountId;
            $scope.account.billingAccount = {
              accountingName: undefined,
              type: undefined,
              accountingId: undefined,
              billingContacts: [{
                email: undefined
              }]
            }
          } else if ($scope.billingAccountMode === "Existing") {
            delete $scope.account.billingAccount;
            $scope.account.billingAccountId = undefined;
          } else if ($scope.billingAccountMode === "Default") {
            _.unset($scope.account, "billingAccount");
            _.unset($scope.account, "billingAccountId")
          }
        }

        $scope.onExistingBillingAccountChange = (billingAccount) => {
          $scope.account.billingAccountId = _.get(billingAccount, 'id');
        }

        $scope.create = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const accountCopy = angular.copy($scope.account);
              accountCopy.phoneNumber = self.$filter<any>('bringozPhonePrefix')($scope.account.phoneNumber);

              if (branchId) {
                accountCopy.branchIds = [branchId];
              }

              if (depotId) {
                accountCopy.depotIds = [depotId];
              }

              $scope.loading = true;
              accountsService.createOne(accountCopy)
                .then((createdAccount) => {
                  self.$mdDialog.hide(createdAccount);
                })
                .finally(() => {
                  $scope.loading = false;
                })
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAndAccount');
          }

        }
      }
    })
  }

  editShipper(event, id) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-shipper-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.ready = false;

        self.$shipper(id).$asyncValue()
          .then((shipper) => {
            $scope.shipper = angular.copy(shipper);
            $scope.ready = true;
            $scope.shipper.user.mobilePhone = self.$filter<any>('bringozPhone')(shipper.user.mobilePhone);
            $scope.shipperCopy = angular.copy($scope.shipper);
          })
          .catch((error) => {
            self.$log.error('Failed to $asyncValue, ' +
              'accountDialogService@editShipper \n' + error)
          })

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // ******************************
        //        Internal methods
        // ******************************


        $scope.doUpdate = () => {
          self.changeLoadingState($scope, true);
          self.$shipper(id).$update($scope.shipper)
            .then((_shipper) => {
              self.$mdDialog.hide(_shipper);
            })
            .catch((error) => {
              self.changeLoadingState($scope, false);
              self.$log.error('Failed to edit shipper, ' +
                'accountDialogService@editShipper \n' + error);
            })
        }

        // ******************************
        //        External methods
        // ******************************


        $scope.onLogoUpload = (res) => {
          $scope.logoStatus = 'complete';
          $scope.shipper.user.avatarUrl = _.get(res, 'data.url');
        }

        $scope.onDeleteAccountAvatar = () => {
          $scope.logoStatus = 'idle';
          $scope.shipper.user.avatarUrl = undefined;
        }


        $scope.onUserChange = (user) => {
          $scope.shipper.user = user;
        }

        $scope.onLoadingChange = (loading) => {
          $scope.loading = loading;
        }

        $scope.submit = (form) => {

          form.$setSubmitted(true);

          if (form.$valid) {
            if ($scope.shipper) {

              if (!_.isEqual($scope.shipper, $scope.shipperCopy)) {
                $scope.shipper.user.mobilePhone = self.$filter<any>('bringozPhonePrefix')($scope.shipper.user.mobilePhone);
                $scope.doUpdate();
              } else {
                self.$mdDialog.hide();
              }

            } else {
              self.$log.error('Shipper copy not found! \n' +
                '--> accountDialogService@editAccountDialog@update');
            }

          }

        }


      }
    })
  }

  editShipperAccount(event, account: AccountModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-shipper-account-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.account = angular.copy(account);
        $scope.account.phoneNumber = self.$filter<any>('bringozPhone')(account.phoneNumber);

        if (account.avatarUrl) {
          $scope.logoStatus = 'complete';
        }

        $scope.loading = false;
        $scope.billingAccountMode = "Existing";
        $scope.logoStatus = 'idle';

        $scope.onBillingAccountModeChange = (billingAccountMode) => {
          $scope.billingAccountMode = billingAccountMode;
          if ($scope.billingAccountMode === "New") {
            delete $scope.account.billingAccountId;
            $scope.account.billingAccount = {
              accountingName: undefined,
              type: undefined,
              accountingId: undefined,
              billingContacts: [{
                email: undefined
              }]
            }
            return;
          }
          if ($scope.billingAccountMode === "Existing") {
            delete $scope.account.billingAccount;
            $scope.account.billingAccountId = undefined;
          }
        }

        $scope.onExistingBillingAccountIdChange = (billingAccount) => {
          $scope.account.billingAccountId = _.get(billingAccount, 'id');
        }

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // ******************************
        //        External methods
        // ******************************

        $scope.submit = (form) => {

          form.$setSubmitted(true);

          if (form.$valid) {

            if (!_.isEqual($scope.account, account)) {
              if ($scope.account) {
                const errorMessage = 'Failed to edit shipper account, accountDialogService@editShipperAccount@doUpdateAccount';
                self.doUpdateAccount($scope, $scope.account.id, $scope.account, errorMessage)
              } else {
                self.$log.error('Account copy not found! \n' +
                  '--> accountDialogService@editAccountDialog@update');
              }
            } else {
              self.$mdDialog.hide();
            }
          }
        }

        $scope.onLogoUpload = (res) => {
          $scope.logoStatus = 'complete';
          $scope.account.avatarUrl = _.get(res, 'data.url');
        }

        $scope.onDeleteAccountAvatar = () => {
          $scope.logoStatus = 'idle';
          $scope.account.avatarUrl = undefined;
        }

      }
    })
  }

  createNewVehicle(event, account) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-add-new-vehicle-template.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, VehiclesConstants) {

        $scope.loading = false;
        $scope.disableBtn = false;
        $scope.vehicleTypes = self.vehicleTypes;
        $scope.colors = VehiclesConstants.colors;

        $scope.payload = {
          active: false
        };

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        // ******************************
        //        External methods
        // ******************************

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {

              if (!account.vehicles) {
                account.vehicles = [];
              }

              account.vehicles.push($scope.payload);

              const errorMessage = 'Failed to create new vehicle, accountDialogService@createNewVehicle';
              self.doPostAccount($scope, account.id, account, errorMessage);

            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  editVehicleInfo(event, account, index) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-edit-vehicle-info-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.disableBtn = false;
        $scope.vehicleTypes = self.vehicleTypes;

        $scope.accountCopy = angular.copy(account);
        $scope.payload = angular.copy(account.vehicles[index]);
        $scope.payloadCopy = angular.copy(account.vehicles[index]);

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {


              const payloadChangeTest = angular.toJson($scope.payload),
                payloadCopyChangeTest = angular.toJson($scope.payloadCopy);

              if (!_.isEqual(payloadChangeTest, payloadCopyChangeTest)) {

                $scope.accountCopy.vehicles[index] = $scope.payload;

                const errorMessage = 'Fail to edit vehicle, accountDialogService@createNewVehicle@create';
                self.doPostAccount($scope, account.id, $scope.accountCopy, errorMessage);
              } else {
                self.$mdDialog.hide();
              }
            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  editVehicleRegistration(event, account, index) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-edit-vehicle-registration-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, uploadFile) {

        $scope.loading = false;
        $scope.disableBtn = false;

        $scope.accountCopy = angular.copy(account);
        $scope.payload = angular.copy(account.vehicles[index]);
        $scope.payloadCopy = angular.copy(account.vehicles[index]);

        $scope.status = $scope.payload.registrationImageUrl ? 'complete' : 'idle';

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // ******************************
        //        External methods
        // ******************************


        $scope.upload = ($files) => {
          if (!_.isEqual($files, null) && !_.isEmpty($files)) {
            $scope.disableBtn = true;
            $scope.status = 'uploading';
            uploadFile($files[0])
              .then((response) => {
                $scope.payload.registrationImageUrl = _.get(response, 'data.url');
                $scope.status = 'complete';
                $scope.disableBtn = false;
              })
              .catch((error) => {
                self.$log.error('Failed to upload image to server, ' +
                  'accountDialogService@editVehicleRegistration@upload \n' + error);
              })
          }
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {

              const payloadChangeTest = angular.toJson($scope.payload),
                payloadCopyChangeTest = angular.toJson($scope.payloadCopy);

              if (!_.isEqual(payloadChangeTest, payloadCopyChangeTest)) {

                $scope.accountCopy.vehicles[index] = $scope.payload;

                const errorMessage = 'Fail to edit vehicle, accountDialogService@createNewVehicle@create';
                self.doPostAccount($scope, account.id, $scope.accountCopy, errorMessage);
              } else {
                self.$mdDialog.hide();
              }
            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  editVehicleInsurance(event, account, index) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-edit-vehicle-insurance-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, uploadFile) {

        $scope.loading = false;
        $scope.disableBtn = false;

        $scope.accountCopy = angular.copy(account);
        $scope.payload = angular.copy(account.vehicles[index]);
        $scope.payloadCopy = angular.copy(account.vehicles[index]);

        $scope.status = $scope.payload.insuranceImageUrl ? 'complete' : 'idle';

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        // ******************************
        //        External methods
        // ******************************


        $scope.upload = ($files) => {
          if (!_.isEqual($files, null) && !_.isEmpty($files)) {

            $scope.disableBtn = true;

            $scope.status = 'uploading';
            uploadFile($files[0])
              .then((response) => {

                $scope.payload.insuranceImageUrl = _.get(response, 'data.url');
                $scope.status = 'complete';
                $scope.disableBtn = false;
              })
              .catch((error) => {
                self.$log.error('Failed to upload image to server, ' +
                  'accountDialogService@editVehicleRegistration@upload \n' + error);
              })
          }
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {

              const payloadChangeTest = angular.toJson($scope.payload),
                payloadCopyChangeTest = angular.toJson($scope.payloadCopy);

              if (!_.isEqual(payloadChangeTest, payloadCopyChangeTest)) {

                $scope.accountCopy.vehicles[index] = $scope.payload;

                const errorMesage = 'Fail to edit vehicle, accountDialogService@createNewVehicle@create';
                self.doPostAccount($scope, account.id, $scope.accountCopy, errorMesage);
              } else {
                self.$mdDialog.hide();
              }
            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  editVehicleImage(event, account, index) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-edit-vehicle-image-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, uploadFile) {

        $scope.loading = false;
        $scope.disableBtn = false;

        $scope.accountCopy = angular.copy(account);
        $scope.payload = angular.copy(account.vehicles[index]);
        $scope.payloadCopy = angular.copy(account.vehicles[index]);

        $scope.status = $scope.payload.vehicleImageUrl ? 'complete' : 'idle';

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // ******************************
        //        External methods
        // ******************************


        $scope.upload = ($files) => {
          if (!_.isEqual($files, null) && !_.isEmpty($files)) {

            $scope.disableBtn = true;

            $scope.status = 'uploading';
            uploadFile($files[0])
              .then((response) => {
                $scope.payload.vehicleImageUrl = _.get(response, 'data.url');
                $scope.status = 'complete';
                $scope.disableBtn = false;
              })
              .catch((error) => {
                self.$log.error('Failed to upload image to server, ' +
                  'accountDialogService@editVehicleRegistration@upload \n' + error);
              })

          }
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {

              const payloadChangeTest = angular.toJson($scope.payload),
                payloadCopyChangeTest = angular.toJson($scope.payloadCopy);

              if (!_.isEqual(payloadChangeTest, payloadCopyChangeTest)) {

                $scope.accountCopy.vehicles[index] = $scope.payload;

                const errorMessage = 'Fail to edit vehicle, accountDialogService@createNewVehicle@create';
                self.doPostAccount($scope, account.id, $scope.accountCopy, errorMessage);
              } else {
                self.$mdDialog.hide();
              }
            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  editInspectionDocument(event, account, index) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-edit-inspection-document-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, uploadFile) {

        $scope.loading = false;
        $scope.disableBtn = false;

        $scope.accountCopy = angular.copy(account);
        $scope.payload = angular.copy(account.vehicles[index]);
        $scope.payloadCopy = angular.copy(account.vehicles[index]);

        $scope.status = $scope.payload.inspectionDocumentUrl ? 'complete' : 'idle';

        $scope.close = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        // ******************************
        //        External methods
        // ******************************


        $scope.upload = ($files) => {
          if (!_.isEqual($files, null) && !_.isEmpty($files)) {

            $scope.disableBtn = true;

            $scope.status = 'uploading';
            uploadFile($files[0])
              .then((response) => {
                _.set($scope.payload, 'inspectionImageUrl', _.get(response, 'data.url'))
                // $scope.payload.inspectionImageUrl = _.get(response, 'data.url');
                $scope.status = 'complete';
                $scope.disableBtn = false;
              })
              .catch((error) => {
                self.$log.error('Failed to upload image to server, ' +
                  'accountDialogService@editVehicleRegistration@upload \n' + error);
              })
          }
        }

        $scope.submit = (form) => {
          if (form.$valid) {
            if ($scope.payload) {

              const payloadChangeTest = angular.toJson($scope.payload),
                payloadCopyChangeTest = angular.toJson($scope.payloadCopy);

              if (!_.isEqual(payloadChangeTest, payloadCopyChangeTest)) {

                $scope.accountCopy.vehicles[index] = $scope.payload;

                const errorMessage = 'Fail to edit vehicle, accountDialogService@createNewVehicle@create';
                self.doPostAccount($scope, account.id, $scope.accountCopy, errorMessage);
              } else {
                self.$mdDialog.hide();
              }
            } else {
              self.$log.error('$scope.payload not found! \n' +
                '--> accountDialogService@createNewVehicle');
            }
          } else {
            form.$setSubmitted(true);
          }

        }
      }
    })
  }

  importAccounts(event, schemas?: any[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/import-accounts-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, accountsAlerts, accountsConstants) {

        $scope.loading = false;
        $scope.file = undefined;
        $scope.schemaId = undefined;
        $scope.schemaOptionsWrapper = {
          list: _.map(schemas || [], (schema) => ({id: schema.id, name: schema.schemaName})),
          propertyRef: 'name'
        };

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSelectSchema = (schemaId) => {
          $scope.schemaId = schemaId;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onDownloadExample = () => {
          const downloadUrl = accountsConstants.importSampleFileLink;
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-accounts-example.xls";
          document.body.appendChild(a);
          a.click();
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;
            self.accountRequests.uploadAccounts($scope.file, $scope.schemaId)
              .then((response) => {
                self.$mdDialog.hide(response);
              })
              .catch((error) => {
                accountsAlerts.uploadError();
                self.$log.error('Failed to upload excel to server, ' +
                  'deliveriesFileDropUpload@uploadFiles' + error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }
      }
    })
  }

  showAccountsList(event, accountReferences) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/accounts-list-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: false,
      controller: function ($scope) {
        $scope.accountReferences = accountReferences
        $scope.cancel = self.$mdDialog.cancel;

      }
    });
  }

  setProvider(event, accountExternalId?, providerName?, data?: { providerStoreId?: string }) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/account-set-provider-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.selectedProvider = angular.copy(providerName);
        $scope.data = angular.copy(data);
        $scope.accountExternalId = accountExternalId;
        $scope.useProviderStoreId = !!data?.providerStoreId;
        $scope.providersOptions = self.splitService.getSupportedThreePlProviders();

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        // ******************************
        //        External methods
        // ******************************

        $scope.onProviderChange = (selectedProvider) => {
          $scope.selectedProvider = selectedProvider;
        }

        $scope.onUseProviderStoreIdChange = (useProviderStoreId: boolean) => {
          $scope.useProviderStoreId = useProviderStoreId;
          $scope.data = {providerStoreId: undefined};
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payload = {name: $scope.selectedProvider, data: $scope.data};
              self.$mdDialog.hide(payload);
            }

          }
        }

      }
    })
  }


  // ******************************
  //        Internal methods
  // ******************************

  private doPostAccount(scope, accountId, payload, errorMessage) {
    this.changeLoadingState(scope, true);
    this.$account(accountId).$post(payload)
      .then((updatedAccount) => {
        this.$mdDialog.hide(updatedAccount);
      })
      .catch((error) => {
        this.changeLoadingState(false);
        this.$log.error(errorMessage + '\n' + error);
      })
  }

  private doUpdateAccount(scope, accountId, payload, errorMessage) {
    this.changeLoadingState(scope, true);
    payload.phoneNumber = this.$filter<any>('bringozPhonePrefix')(payload.phoneNumber);
    scope.isLoading = true;
    this.$account(accountId).$update(payload)
      .then((updatedAccount) => {
        this.$mdDialog.hide(updatedAccount);
      })
      .catch((error) => {
        this.changeLoadingState(scope, false);
        this.$log.error(errorMessage + '\n' + error);
      })
      .finally(() => {
        scope.isLoading = false;
      })
  }

  private changeLoadingState(scope, state?) {
    scope.loading = state;
    this.$rootScope.$broadcast(this.systemEventsConfig.forms.fieldsetToggle, state);
  }


}

angular
  .module('bringoz.admin.accounts')
  .service('accountDialogService', AccountDialogService);
